import React, { useState } from "react";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import ProductDetailsOne from "../components/ProductDetailsOne";
import ShippingOne from "../components/ShippingOne";
import NewsletterOne from "../components/NewsletterOne";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import Breadcrumb from './../components/Breadcrumb';
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";

const ProductDetailsPageOne = () => {

  const [selectedCurrency, setSelectedCurrency] = useState(
    localStorage.getItem("selectedCurrency")
  );

  const handleCurrencyChange = (currency) => {
    setSelectedCurrency(currency);
    localStorage.setItem("selectedCurrency", currency);
  };

  return (
    <>

      {/* Preloader */}
      <Preloader />

      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      {/* <ScrollToTop smooth color="#e54b24" /> */}

      {/* HeaderOne */}
      <HeaderOne />

      {/* Breadcrumb */}
      {/* <Breadcrumb title={"Item Details"} /> */}

      {/* ProductDetailsOne */}
      <ProductDetailsOne selectedCurrency={selectedCurrency} />
      
      {/* ShippingOne */}
      <ShippingOne />

      {/* NewsletterOne */}
      <NewsletterOne />

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      {/* <BottomFooter /> */}



    </>
  );
};

export default ProductDetailsPageOne;
